import React, { useContext, useEffect, useState } from 'react'
import { MapContext } from '../../component'
import mapboxgl from 'mapbox-gl'

export const ScaleControl = ({
  options,
  position,
  getControl
}: {
  options?: { maxWidth?: number; unit?: string }
  position?: controlPositions
  getControl?: (a: mapboxgl.NavigationControl) => void
}) => {
  const map = useContext(MapContext)
  const [control, setControl] = useState<any>(null)

  useEffect(() => {
    if (!map) return
    if (control) map.removeControl(control)
    const newcontrol = new mapboxgl.ScaleControl(options)
    map.addControl(newcontrol, position)
    if (getControl) getControl(newcontrol)
    setControl(newcontrol)
  }, [])
  return null
}
